import React, { useRef, useState } from "react";
import { View, ScrollView, Text } from "react-native";
import { ids, styles } from "./landingPageCss";
import Navbar from "./components/Navbar";
import ExploreSection from "./components/ExploreSection";
import WhyChooseSection from "./components/WhyChooseSection";
import ContactUs from "./components/ContactUs";
import WelcomeSection from "./components/WelcomeSection";
import { whiteColor } from "../../constant/constantCss";
import moment from "moment";
import Career from "./components/Career";
import CompanyReview from "./components/CompanyReview";

const LandingPage = () => {
  const scrollViewRef = useRef(null);
  const [isCareerModalVisible, setIsCareerModalVisible] = useState(false);
  const [isVisibleAddReview, setIsVisibleAddReview] = useState(false);
  const [isVisiblePersonalizedTripModal, setIsVisiblePersonalizedTripModal] =
    useState(false);
  return (
    <View
      style={[
        styles.container,
        {
          opacity:
            isCareerModalVisible ||
            isVisibleAddReview ||
            isVisiblePersonalizedTripModal
              ? 0.9
              : 1,
          filter:
            isCareerModalVisible ||
            isVisibleAddReview ||
            isVisiblePersonalizedTripModal
              ? "blur(5px)"
              : "blur(0px)",
        },
      ]}
      id="about_us"
    >
      {/* Nab bar */}
      <Navbar
        scrollViewRef={scrollViewRef}
        isVisiblePersonalizedTripModal={isVisiblePersonalizedTripModal}
        setIsVisiblePersonalizedTripModal={setIsVisiblePersonalizedTripModal}
      />
      {/* Welcome to Maroon Migrates container */}
      <ScrollView ref={scrollViewRef}>
        <View
          style={styles.mainContainer}
          dataSet={{ media: ids.mainContainer }}
        >
          {/* Welcome section */}
          <WelcomeSection
            isVisiblePersonalizedTripModal={isVisiblePersonalizedTripModal}
            setIsVisiblePersonalizedTripModal={
              setIsVisiblePersonalizedTripModal
            }
          />
          {/* Explore container */}
          <ExploreSection />
          {/* Why choose maroon migrates container */}
          <WhyChooseSection />
          {/* Company review */}
          <CompanyReview
            isVisibleAddReview={isVisibleAddReview}
            setIsVisibleAddReview={setIsVisibleAddReview}
          />
          {/* Career section */}
          <Career
            isCareerModalVisible={isCareerModalVisible}
            setIsCareerModalVisible={setIsCareerModalVisible}
          />
        </View>
        {/* Contact us container */}
        <ContactUs />
        <View style={styles.footerContainer}>
          <Text style={{ color: whiteColor, fontSize: 14, fontWeight: "600" }}>
            {`Copyright © ${moment().format(
              "YYYY"
            )} Maroon Migrates. All rights reserved`}
          </Text>
        </View>
      </ScrollView>
    </View>
  );
};

export default LandingPage;
